import { makeStyles, TableCellLayout } from "@fluentui/react-components";
import { DocumentGridViewItem } from "../../models/DocumentGridViewItem";
import { shouldShowPublishedDocumentNewIndicator } from "../../services/PublishedDocumentNewIndicatorService";
import PublishedDocumentNewIndicator from "./PublishedDocumentNewIndicator";

const useStyles = makeStyles({
  content: {
    alignItems: "center",
    display: "inline-flex",
    maxWidth: "100%",
    minWidth: 0,
    position: "relative",
  },
  fileName: {
    wordBreak: "break-all",
  },
});

interface DocumentGridFileNameCellProps {
  item: DocumentGridViewItem;
  fileName: string;
  showNewIndicator?: boolean;
}

const DocumentGridFileNameCell = (props: DocumentGridFileNameCellProps) => {
  const { item, fileName, showNewIndicator } = props;
  const classes = useStyles();
  const shouldShowNewIndicator =
    showNewIndicator && shouldShowPublishedDocumentNewIndicator(item);

  return (
    <TableCellLayout>
      <span className={classes.content}>
        {shouldShowNewIndicator && <PublishedDocumentNewIndicator />}
        <span className={classes.fileName}>{fileName}</span>
      </span>
    </TableCellLayout>
  );
};

export default DocumentGridFileNameCell;
